import * as React from "react";
import styled from "styled-components";
import Spinner from "components/common/Spinner";
import queryTitle from "views/logic/queries/QueryTitle";
import useView from "views/hooks/useView";
import useActiveQueryId from "views/hooks/useActiveQueryId";
const PositioningWrapper = styled.div`
  padding-left: 20px;
`;
const BigDisplayModeHeader = () => {
  const view = useView();
  const activeQuery = useActiveQueryId();
  if (!view || !activeQuery) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const currentQueryTitle = queryTitle(view, activeQuery);
  return /* @__PURE__ */ React.createElement(PositioningWrapper, null, /* @__PURE__ */ React.createElement("h1", null, view.title), /* @__PURE__ */ React.createElement("h2", null, currentQueryTitle));
};
export default BigDisplayModeHeader;
